import template from './compareClubButton.template.html';

export default {
  template,
  bindings: {
    showLogo: '<',
    idTicket: '<',
    idContact: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isOpenDialog = false;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        this.openDialog = () => {
          ctrl.isOpenDialog = true;
        };
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      this.onCompareClubFinished = (status) => {
        ctrl.isOpenDialog = false;
        ctrl.onFinished({ status });
      };
    }
  }
};
